import { PaymentMethodEnum } from '@/types/common';

export const AVILABLE_PAYMENT_METHOD_COUNT = 4;

export const REDIRECT_PAYMENT_POLLING_INTERVAL = 1000;

// Stripe methods whose redirect polling has no automatic exit, because they
// can't trust `tab.closed` (Stripe's `afterpay_clearpay`; see
// `StripePaymentHandler.poll`). Those shoppers need a manual way out of the
// processing overlay, offered as soon as it appears. Scoped to Stripe on
// purpose — the same method behind another PSP keeps a usable tab handle and
// exits on its own, so it must not get the button. Callers pair this with a
// `provider === ProviderEnum.STRIPE` check.
export const StripeRedirectMethodsWithManualCancel: PaymentMethodEnum[] = [
  PaymentMethodEnum.AFTERPAY,
  PaymentMethodEnum.CLEARPAY,
];

export const MAXIMUM_CREDIT_CARD_ALLOWED = 50;

export const AVILAIBLE_PAYMENT_METHODS_WITHOUT_OTHER = 3;

export const MAX_LENGTH_CVC = 4;

export const BLIK_CODE_LENGTH = 6;

export const PaymentMethodsToShowLoaderWhileProcessing: PaymentMethodEnum[] = [
  // Methods here do not render our in-app PayButton spinner while their native
  // sheet / redirect flow is in progress. Card and PayPal APM PayButton flows
  // deliberately stay out of this list to avoid a second full-screen loader.
  PaymentMethodEnum.LINK,
  PaymentMethodEnum.APPLE_PAY,
  PaymentMethodEnum.GOOGLE_PAY,
  PaymentMethodEnum.AMAZON_PAY,
];

// Methods that show the full-screen overlay during the post-authorization
// order-polling window (gated on `successScreen.isOpen` in <ProcessingLoader/>),
// so the shopper never drops back to the bare checkout form + PayButton spinner
// once the intent is authorized and we're only waiting on the order/webhook.
//
// Membership is an explicit per-method UX policy — deliberately NOT derived from
// the Stripe routing lists (e.g. `stripeInPageActionApmMethods`) — so a method's
// loader behavior stays decoupled from how its next-action happens to resolve.
// The methods here reach this window from different auth phases but share the
// same "overlay during polling" tail:
//   - BLIK (Stripe, client-confirmed via `stripe.confirmBlikPayment`), Bizum and
//     MB WAY (Stripe in-page-action APMs, server-finalized + `handleNextAction`,
//     approved in the shopper's banking / MB WAY app): their in-app authorization
//     overlay covers auth, then this overlay takes over during polling.
//   - Swish (Stripe, top-level PAYMENT_HANDLER tab): <RedirectPayment/>'s own
//     overlay covers auth while it polls the intent, but that overlay is torn
//     down on PI success (`setRedirectPayment({})`) — this list is what keeps a
//     full-screen loader up through the order-polling tail instead of the
//     PayButton spinner.
export const PaymentMethodsToShowLoaderWhilePolling: PaymentMethodEnum[] = [
  PaymentMethodEnum.BLIK,
  PaymentMethodEnum.BIZUM,
  PaymentMethodEnum.SWISH,
  PaymentMethodEnum.MBWAY,
];
